import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const navLinks = [
    { name: '首页', path: '/' },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <header className={`w-full z-50 transition-all duration-300 ${isHome ? 'absolute top-0 left-0' : 'sticky top-0 bg-background-50/95 backdrop-blur-md border-b border-background-200/70'}`}>
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="text-2xl font-bold font-heading text-primary-500 whitespace-nowrap">叮当漫画</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-500'
                    : isHome ? 'text-white hover:text-primary-300' : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.name}
              </Link>
            ))}

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  isHome ? 'text-white hover:text-primary-300' : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg border border-background-200/70 shadow-lg py-2 z-50">
                  <div className="grid grid-cols-1">
                    {categories.slice(0, 8).map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        onClick={() => setCategoryOpen(false)}
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap"
                      >
                        <i className={`${cat.icon} text-base`}></i>
                        {cat.name}
                      </Link>
                    ))}
                    <Link
                      to="/category/all"
                      onClick={() => setCategoryOpen(false)}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-primary-500 hover:bg-background-100 transition-colors duration-150 border-t border-background-200/70 mt-1 pt-2.5 whitespace-nowrap"
                    >
                      <i className="ri-apps-line text-base"></i>
                      全部分类
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 cursor-pointer ${
              isHome ? 'text-white hover:bg-white/10' : 'text-foreground-600 hover:bg-background-100'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 cursor-pointer ${
              isHome ? 'text-white hover:bg-white/10' : 'text-foreground-600 hover:bg-background-100'
            }`}>
              <i className="ri-user-line text-lg"></i>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors duration-200 cursor-pointer ${
              isHome ? 'text-white hover:bg-white/10' : 'text-foreground-600 hover:bg-background-100'
            }`}
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`block px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-150 ${
                  location.pathname === link.path
                    ? 'bg-primary-50 text-primary-500'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="border-t border-background-200/70 pt-2 mt-2">
              <p className="px-3 py-1 text-xs text-foreground-500 font-medium">分类浏览</p>
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setMobileOpen(false)}
                  className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors duration-150"
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}